
import React, { memo } from 'react';

import { Icon, IconCheck, IconExclamationSolid } from '../../../../base/icons';

/**
 * The type of the React {@code Component} props of {@link AudioSettingsEntry}.
 */
export type Props = {

  /**
   * The text for this component.
   */
  children: React$Node,

  /**
   * Flag indicating an error.
   */
  hasError?: boolean,

  /**
   * Flag indicating the selection state.
   */
  isSelected: boolean,
};

/**
 * React {@code Component} representing an entry for the audio settings.
 *
 * @returns { ReactElement}
 */
const AudioSettingsEntry = ({
    children,
    hasError,
    isSelected
}: Props) => {
    const className = `audio-preview-entry ${
        isSelected ? 'audio-preview-entry--selected' : ''
    }`;
    const audioPreview = `audio-preview-entry-text ${
        isSelected ? 'audio-preview-entry-text--selected' : ''
    }`;

    return (
        <div className = { className }>
            {isSelected && (
                <Icon
                    className = 'audio-preview-icon audio-preview-icon--check'
                    color = '#1C2025'
                    size = { 14 }
                    src = { IconCheck } />
            )}
            <p
                className = { audioPreview }
                title = { children }>{children}</p>
            {hasError && (
                <Icon
                    className = 'audio-preview-icon audio-preview-icon--exclamation'
                    size = { 16 }
                    src = { IconExclamationSolid } />
            )}
        </div>
    );
};

export default memo(AudioSettingsEntry);
